import React from 'react';
import styled from 'styled-components';
import { VehicleModelProps } from './car-model';
import { VehiclePart } from '../../enums';
import VehicleStateImg from './vehicle-state-img';
import FrontHoodImg from '../../assets/images/car-model/front_hood.png';
import RearHoodImg from '../../assets/images/car-model/rear_hood.png';

interface Props extends VehicleModelProps {
  part: VehiclePart;
}

const HOOD_IMGS = {
  [VehiclePart.Front]: FrontHoodImg,
  [VehiclePart.Rear]: RearHoodImg,
};

const HOOD_STYLES = {
  [VehiclePart.Front]: 0.34,
  [VehiclePart.Rear]: -2.3,
};

class VehicleHood extends React.Component<Props, any> {
  getVehicleItem = () => `${this.props.part}-hood`;

  clickHandler = () => {
    const { clickHandler } = this.props;
    clickHandler && clickHandler(this.getVehicleItem());
  };

  render() {
    const { className, part, vehicleState } = this.props;
    const vehicleItem = this.getVehicleItem();

    return (
      <VehicleStateImg
        className={`${className} ${vehicleState[vehicleItem]}`}
        src={HOOD_IMGS[part]}
        onClick={this.clickHandler}
      />
    );
  }
}

const StyledVehicleHood = styled(VehicleHood)`
  position: relative;
  width: 8em;
  top: ${({ part }) => HOOD_STYLES[part]}em;
`;

export default StyledVehicleHood;
